<script>
import { ref, onMounted, inject } from 'vue';
import ApiHelper from '../helpers/apiHelper';

export const checkDiscountCodeApi = async (discountCode) => {
  if (!discountCode) return false;
  // Check if the discount code exists and if it has uses left
  const apiUrl = `${__API_URL__}/discounts/${discountCode}`;
  const apiHelper = new ApiHelper(apiUrl, 'GET', '');
  const response = await apiHelper.fetchData();
  if (response.status !== 200 && response.status !== 204) return false;
  return response.data.uses_left > 0 || false;
}

export default {
  setup() {
    const globalDiscount = inject('discountAvailable');
    let userDiscountCode = ref('');
    let userMessage = ref('');

    onMounted(() => {});

    const handleInput = (event) => {
      // Allow only alphanumeric characters for the discount code field
      userDiscountCode.value = event.target.value.replace(/[^a-zA-Z0-9]/g, '');
    }

    const applyDiscountCode = async (discountCode) => {
      globalDiscount.value = await checkDiscountCodeApi(discountCode);

      // If discount code was valid store info in localstorage so user keeps the discount after refreshing the page
      if (globalDiscount.value) {
        localStorage.setItem(`discount_code_applied_1`, JSON.stringify(discountCode));
      }

      userMessage.value = globalDiscount.value ? 'Ihr corporate benefits Rabatt wurde angewendet.' : 'Der Gutschein ' + userDiscountCode.value +' existiert nicht!';
    }

    return {
      userMessage,
      globalDiscount,
      userDiscountCode,
      handleInput,
      applyDiscountCode
    };
  }
};
</script>

<template>
  <div class="stepper__input discount-code-wrapper">
    <div class="field discount-code-field">
      <div class="field-left">
        <label>Haben Sie einen corporate benefits Gutscheincode?</label>
        <input
          v-model="userDiscountCode"
          :class="{ 'input': true }"
          placeholder="Gutscheincode"
          type="text"
          name="discount_code_input"
          @input="handleInput"
        >
      </div>
      <div class="field-right">
        <button class="button button--discount" @click="applyDiscountCode(userDiscountCode)">Gutschein anwenden</button>
      </div>
    </div>
  </div>
  <div v-if="!globalDiscount && userMessage" class="discount-active error">
    <span> {{ userMessage }} </span>
  </div>
  <div v-if="globalDiscount" class="discount-active">
    <span> Ihr corporate benefits Rabatt wurde angewendet. Gilt nicht für den Partnertarif. </span>
  </div>
</template>

<style scoped lang="scss">
.discount-code-wrapper {
  display: flex;
  width: 100%;
  justify-content: start;
  margin: 0 0 5rem 1rem;
  @media only screen and (max-width: 600px) {
    flex-wrap: wrap;
  }

  .discount-code-field {
    display: flex;
    gap: 1.2rem;
    @media only screen and (max-width: 600px) {
      flex-direction: column;
      width: 100%;
    }

    .field-left {
      display: flex;
      flex-direction: column;
      label {
        font-size: 14px;
      }
      input {
        height: 4.5rem;
      }
    }

    .field-right {
      display: flex;
      flex-direction: column;
      justify-content: end;

      .button--discount {
        margin-top: 0;
      }
    }
  }
}

div.discount-active {
  text-align: center;
  color: green;
  font-size: 20px;
  background: #deff00;
  padding: 10px;
  margin: 0 0 1rem 1rem;
  &.error {
    border: 1px solid #eb003c;
    background: #eb003c;
    color: #ffffff;
  }
}
</style>
